import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import "../../assets/css/modal.css";
import "../../assets/css/custom.css";
import testImng from "../../assets/images/icon/heart.png";
import testIcon from "../../assets/images/icon/api1.png";
import testIcon2 from "../../assets/images/icon/api2.png";
import testIcon3 from "../../assets/images/icon/api3.png";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { apiKeyState } from "../../atom/ApiKey";
import { CreateApi } from "../../api/apiKey/CreateApi";
export default function ApiMobailBar({ data }) {
  const [copied, setCopied] = useState(false);
  const [isSuccess, setSuccess] = useState(false);
  const [apiKeys, setApiKeys] = useRecoilState(apiKeyState);

  const getIconForProduct = (name) => {
    if (name === "국민건강보험공단 API") return testIcon;
    if (name === "광학문자인식 API") return testIcon3;
    if (name === "어종검출 API") return testIcon2;
    return testIcon;
  };

  const handleCopy = (text) => {
    if (!text) return;
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleCreateSuccessKey = () => {
    setSuccess(true);
    setTimeout(() => setSuccess(false), 3000);
  };

  const handleCreateKey = async (data) => {
    try {
      const resp = await CreateApi({
        product_id: data?.product_id,
        stage_id: data?.stage_id,
        usage_id: data?.usage_id,
        is_test: true,
      });

      if (resp?.status === 200) {
        const newKey = resp.data;

        setApiKeys((prevKeys) => [...prevKeys, newKey]);
      }
      handleCreateSuccessKey();

      if (resp?.response?.status === 400) {
        if (resp.response.data.message === "이미 api key가 존재합니다.") {
        }
      }
    } catch (error) {
      console.log("API KEy 생성 실패 error", error.status);
      return;
    }
  };

  return (
    <div className="modal-mobile-list-select">
      <div
        className="modal-mobile-flex-box"
        onClick={() => handleCopy(data?.apikey)}
      >
        <div className="modal-mobile-flex-box2">
          <img
            className="modal-mobile-flex-box3"
            src={getIconForProduct(data?.product_name)}
          />
        </div>
        <div className="modal-mobile-flex-box4">
          <div>{data?.product_name}</div>
          {data?.apikey && (
            <div style={{ fontSize: `12px` }}>
              {data.apikey.length > 20
                ? `${data.apikey.slice(0, 5)}...${data.apikey.slice(-6)}`
                : data.apikey}
            </div>
          )}{" "}
        </div>
      </div>
      {!data?.apiKey && (
        <div
          className="modal-mobile-select-box"
          onClick={() => handleCreateKey(data)}
        >
          <IoMdCheckmarkCircleOutline size={20} />
        </div>
      )}
      {copied && (
        <div
          style={{
            position: "fixed",
            display: `flex`,
            bottom: "10vh",
            height: `60px`,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#1977F3",
            color: "white",
            padding: "12px 36px",
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            zIndex: 9999,
            fontWeight: 600,
            fontSize: "18px",
            justifyContent: `center`,
            alignItems: `center`,
            fontWeight: `800`,
          }}
        >
          ✅ API Key가 복사되었습니다.
        </div>
      )}
      {isSuccess && (
        <div
          style={{
            position: "fixed",
            display: `flex`,
            bottom: "10vh",
            height: `40px`,
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#1977F3",
            color: "white",
            padding: "12px 36px",
            borderRadius: "16px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            zIndex: 9999,
            fontWeight: 600,
            fontSize: "14px",
            justifyContent: `center`,
            alignItems: `center`,
            fontWeight: `800`,
          }}
        >
          ✅ TestAPI 신청이 완료되었습니다.
        </div>
      )}
    </div>
  );
}
